import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { LoginPage } from './pages/Login.js';
import { DrivePage } from './pages/Drive.js';
import { EarningsPage } from './pages/Earnings.js';
import { AccountPage } from './pages/Account.js';
import { useSession } from './state/session.js';
import { IS_DEMO } from './demo/config.js';

function RequireAuth({ children }: { children: JSX.Element }) {
  const token = useSession((s) => s.accessToken);
  const location = useLocation();
  if (!token) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={IS_DEMO ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <DrivePage />
          </RequireAuth>
        }
      />
      <Route
        path="/earnings"
        element={
          <RequireAuth>
            <EarningsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/account"
        element={
          <RequireAuth>
            <AccountPage />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
